// Ensure all external links are opened in a new tab
// so they don't negatively affect bounce rate,
// especially footer links and blog content
function linkListener (event) {
  const { target } = event;
  if (target.nodeType === Node.ELEMENT_NODE && target.tagName === 'A') {
    const href = target.getAttribute('href');
    const url = new URL(href);
    if (url.hostname !== window.location.hostname) {
      target.setAttribute('target', '_blank');
    }
  }
}
document.addEventListener('click', linkListener);
document.addEventListener('touch', linkListener);
